import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Container, Row, Col, Card } from 'react-bootstrap';
import api from '../../api/axios';
import '../../styles/form.css';
import logo1 from "../../assets/logo/logo-login.png";


const RegisterConsumerForm = () => {
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const validateEmail = email => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const { name, email, password } = form;
    if (!name || !email || !password) {
      setError('Completá todos los campos.');
      return;
    }

    if (!validateEmail(email)) {
      setError('El email no tiene un formato válido.');
      return;
    }

    try {
      setLoading(true);
      await api.post('/users/register-consumer', form);
      navigate('/login');
    } catch (err) {
      const msg = err.response?.data?.message || 'Error al registrarse';
      setError(msg);
      console.error('Error en registro:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="shadow-lg login-card">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <img
                    src={logo1}
                    alt="Logo qrBenefits"
                    style={{ maxWidth: '120px' }}
                    className="mb-3"
                  />
                  <h3 className="mb-1">Crear cuenta</h3>
                  <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                    Registrate para guardar tus beneficios y sumar puntos ✨
                  </p>
                </div>

                {error && (
                  <Alert variant="danger" className="py-2">
                    {error}
                  </Alert>
                )}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="name">
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Ingresá tu nombre"
                      value={form.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Ingresá tu email"
                      value={form.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4" controlId="password">
                    <Form.Label>Contraseña</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Elegí una contraseña"
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Button
                    type="submit"
                    className="w-100 btn-qr-primary"
                    disabled={loading}
                  >
                    {loading ? 'Creando cuenta...' : 'Registrarme'}
                  </Button>
                </Form>

                <div className="text-center mt-3">
                  <small className="text-muted">
                    ¿Ya tenés cuenta?{' '}
                    <button
                      type="button"
                      className="btn btn-link p-0 text-qr-primary"
                      onClick={() => navigate('/login')}
                    >
                      Iniciá sesión
                    </button>
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RegisterConsumerForm;
